export enum VesselListFormValue {
  DESCRIPTION = 'Description',
}
